import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlightMealService } from '@common/services/my-booking/flight-meal-service/flight-meal-service';
import { ButtonModule, TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { AmountFormatModule, StaticMsgModule, StaticMsgPipe } from '@lib/pipes';
import { DialogDisplayServiceModule, ModalServiceModule } from '@lib/services';
import { TranslateModule } from '@ngx-translate/core';
import { FlightMealRequestComponent } from './flight-meal-request.component';
import { FlightMealTravelerModule } from './sub-components/flight-meal-traveler/flight-meal-traveler.module';

@NgModule({
  declarations: [FlightMealRequestComponent],
  providers: [StaticMsgPipe, FlightMealService],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    StaticMsgModule,
    DialogDisplayServiceModule,
    ButtonModule,
    TextTooltipModule,
    ModalServiceModule,
    AmountFormatModule,
    TooltipDirectiveModule,
    FlightMealTravelerModule,
  ],
  exports: [FlightMealRequestComponent],
})
export class FlightMealRequestModule {}
